/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//二手车
const usedCarLayout = require('src/appBackend/components/page/usedCar/used-car-layout/used-car-layout');
const usedCarList = require('src/appBackend/components/page/usedCar/used-car-list/used-car-list');

module.exports = {
  "component": usedCarLayout,
  "subRoutes": {
    "/list": {
      "title": "二手车列表",
      "component": usedCarList
    }
  }
}





// WEBPACK FOOTER //
// ./src/appBackend/router/usedCar.js